import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { editNoteSellOrderIdStudent, querySellOrderIdl, sendMessage, getWeekSendMessage, getImageByName, getUploadWebError, evaluationExport, evaluationSellOrder, addEvaluationInspector, editEvaluationInspector, getWeekStrPDF, exportWeekStrPDF, getFeedbackGetcontent } from '@/api'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import urlBase from '@/utils/urlBase'

@Component({ name: 'feedBack', components: { } })
export default class FeedBack extends Vue {
  @Prop({ type: Object, default: {} }) activeStudent !: object;
  @Prop({ type: Number, default: {} }) pageType !: number; // 1，个人消息 2，班级消息

  created () {
    this.activeData = this.activeStudent
    this.getSellOrderIdl(this.activeStudent)
  }

  private uploadUrl = {
    // imgs: this.$APIurl + 'upload/evaluation/image'
    imgs: urlBase.eduBaseUrl + 'upload/evaluation/image'
  }

  private weekStr = '第一周'
  private exportinfo: any = null // 导出的等待状态
  private tainfo: any = 'null'
  private dialogImageUrl: any = null
  private dialogVisible: any = false
  private weeksVisible: any = false
  private weeksradio: any = null
  private checkedWeeks: any = []
  private weekList: any = [{ name: '第一节', val: 1 }, { name: '第二节', val: 2 }, { name: '第三节', val: 3 }, { name: '第四节', val: 4 }, { name: '第五节', val: 5 }, { name: '第六节', val: 6 }, { name: '第七节', val: 7 }]
  private activeData: any = {}
  private messageType: any = null
  private returnData: any = {}
  private qualityList: any = [{}]
  private exportWeekFeedback: any = false
  private exportWeekFeedbackExcel: any = false
  private exportcheckedWeeks: any = []
  private exportcheckedWeeksExcel: any = []
  private importWeeksList: any = []
  private exportDataPdf: any = null
  private exportDataPdfData: any = null
  private allExportDataPdf: any = {}
  private screenUrl: any = null
  private gradientColor: any = '#4982FF'
  private courseTypeId: any = null

  // 传入的学员信息
  @Watch('activeStudent')
  activeStudentchange (val: any, old: any) {
    if (JSON.stringify(this.evaluationAllWeekList) !== this.evaluationAllWeekListCopy && JSON.stringify(val) !== JSON.stringify(old)) {
      if (this.$store.state.user.roles.find((item: any) => item.indexOf('运营专员') > -1 || item.indexOf('运营主管') > -1 || item.indexOf('普通助教') > -1)) {
        this.loading = this.$loading({
          lock: true,
          text: '自动保存中',
          spinner: 'el-icon-loading'
        })
        this.savestudentDetails(1, val)
      }
    } else {
      this.getSellOrderIdl(val)
    }
  }

  private loading: any = false
  private weekActive: any = 0
  private weekActiveimg: any = 0
  private evaluationAllWeekList: any = []
  private evaluationAllWeekListCopy: any = []

  // 弃用老版
  private async downloadPDF1 (ele: any, pdfName: any) {
    window.scrollTo(0, 0)
    const eleW: any = ele.offsetWidth// 获得该容器的宽
    const eleH: any = ele.offsetHeight// 获得该容器的高
    const eleOffsetTop: any = ele.offsetTop // 获得该容器到文档顶部的距离
    const eleOffsetLeft: any = ele.offsetLeft // 获得该容器到文档最左的距离
    const canvas: any = document.createElement('canvas')
    let abs: any = 0
    const winin: any = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
    const winout: any = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
    if (winout > winin) {
      abs = (winout - winin) / 2 // 获得滚动条宽度的一半
    }
    canvas.width = eleW * 2 // 将画布宽&&高放大两倍
    canvas.height = eleH * 2
    const context: any = canvas.getContext('2d')
    context.scale(2, 2)
    context.translate(-eleOffsetLeft - abs, -eleOffsetTop)
    html2canvas(ele, {
      useCORS: true // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
    }).then(async (canvas) => {
      const contentWidth: any = canvas.width
      const contentHeight: any = canvas.height
      // 一页pdf显示html页面生成的canvas高度;
      const pageHeight: any = contentWidth / 595.28 * 906
      // 未生成pdf的html页面高度
      let leftHeight: any = contentHeight
      // 页面偏移
      let position: any = 0
      // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      const imgWidth: any = 595.28
      const imgHeight: any = 595.28 / contentWidth * contentHeight
      const pageData: any = canvas.toDataURL('image/jpeg', 1.0)
      const pdf: any = new JsPDF(undefined, 'pt', 'a4')
      // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(906)
      if (leftHeight < pageHeight) {
        // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
      } else { // 分页
        while (leftHeight > 10) {
          console.log(leftHeight)
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
          leftHeight -= pageHeight
          position -= 906
          // 避免添加空白页
          if (leftHeight > 10) {
            pdf.addPage()
          }
        }
      }
      // 可动态生成
      pdf.save(pdfName)
      this.$message({ type: 'success', message: '导出图片成功' })
      this.loading.close()
      this.exportinfo = null
      await evaluationExport({ studentName: this.activeData.studentName })
    })
  }

  // 把页面导出PDF
  private async downloadPDF (ele: any, pdfName: any) {
    window.scrollTo(0, 0)
    html2canvas(ele, {
      useCORS: true,
      scale: ele.offsetHeight > 5000 ? 1.2 : 2,
      allowTaint: false
    }).then(async (canvas) => {
      const pageData: any = canvas.toDataURL('image/png', 1.0)
      this.screenUrl = pageData
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.download = pdfName
      a.href = this.screenUrl
      await a.dispatchEvent(event)
      setTimeout(async () => {
        this.loading.close()
      }, 3000)
    })
  }

  // 获取详情
  private async getSellOrderIdl (val: any) {
    const list: any = [{ pathName: 'editNoteSellOrderIdStudent', path: '/evaluation/editNoteForSellOrder' }, { pathName: 'sendMessage', path: '/wx/sendMessage' }]
    this.loading = this.$loading({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading'
    })
    this.activeData = val
    const result: any = await querySellOrderIdl({ sellOrderId: val.sellOrderId, classId: val.classId, from: this.pageType, isCurrentClass: val.isCurrentClass, createStr: val.createStr, pathList: list })
    try {
      this.returnData = result
      this.courseTypeId = this.returnData.courseTypeId
      this.evaluationAllWeekList = result.evaluationAllWeek
      this.evaluationAllWeekListCopy = JSON.stringify(this.evaluationAllWeekList)
      // 回访内容
      if (this.$store.state.user.roles.find((item: any) => item.indexOf('普通助教') < 0)) {
        const result1: any = await evaluationSellOrder({ classId: val.classId, sellOrderId: val.sellOrderId })
        this.qualityList = result1.inspector
        if (!this.qualityList.length) {
          this.qualityList.push({ detail: '' })
        }
      }
      this.loading.close()
    } catch {
      this.loading.close()
    }
  }

  // 修改反馈接口
  private async savestudentDetails (type: any, val: any) {
    if (type === 1) {
      this.loading.close()
      const { error }: any = await editNoteSellOrderIdStudent({ changeList: this.evaluationAllWeekList, sellOrderId: this.activeData.sellOrderId, classId: this.activeData.classId, isCurrentClass: this.activeData.isCurrentClass, createStr: this.activeData.createStr })
      if (!error) {
        this.$message({ type: 'success', message: '修改反馈成功' })
      }
      this.getSellOrderIdl(val)
    } else {
      if (JSON.stringify(this.evaluationAllWeekList) === this.evaluationAllWeekListCopy) {
        this.$message({ type: 'warning', message: '未任何修改' })
      } else {
        const { error }: any = await editNoteSellOrderIdStudent({ changeList: this.evaluationAllWeekList, sellOrderId: this.activeData.sellOrderId, classId: this.activeData.classId, isCurrentClass: this.activeData.isCurrentClass, createStr: this.activeData.createStr })
        if (!error) {
          this.$message({ type: 'success', message: '修改反馈成功' })
        }
      }
    }
  }

  private handleRemove1 (obj: any, file: any, fileList: any) {
    if (fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
  }

  private async handleupload (file: any) {
    this.loading = this.$loading({
      lock: true,
      text: '拼命加载中',
      spinner: 'el-icon-loading'
    })
    return true
  }

  private async handleSuccess1 (obj: any, response: any, file: any, fileList: any) {
    if (response === 'ok' || file.response === 'ok') {
      await getUploadWebError(file)
    }
    if (fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
    this.loading.close()
  }

  private async refreshImg (item: any) {
    const data: any = await getImageByName({ name: item.name })
    if (data && data.url) {
      this.$set(item, 'url', data.url)
    } else {
      this.$message({ message: '刷新失败', type: 'error' })
    }
  }

  private deletePreview1 (item: any, index: any) {
    item.answer.splice(index, 1)
  }

  private mouseOver (item: any) {
    this.$set(item, 'isShowIcon', true)
  }

  private mouseLeave (item: any) {
    this.$set(item, 'isShowIcon', false)
  }

  private cilckweek (item: any, list: any) {
    this.$nextTick(() => {
      list.forEach((item1: any) => {
        if (item1.weekId === item.weekId) {
          this.$set(item1, 'isShow', true)
        } else {
          this.$set(item1, 'isShow', false)
        }
      })
    })
  }

  private questionta (item: any) {
    if (item.answer) {
      let len = 0
      for (let i = 0; i < item.answer.length; i++) {
        const c = item.answer.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          len++
        } else {
          len += 2
        }
      }
      if (len < 600 && this.courseTypeId * 1 !== 1) {
        this.$message({ message: 'TA评价不可少于600个字符', type: 'warning' })
        const pwdElem: any = this.$refs.TAinput
        pwdElem[this.weekActive].focus()
        this.tainfo = false
      } else {
        this.tainfo = true
      }
    }
  }

  private chertinput (item: any) {
    const t = /^[0-9./{1}]+$/
    if (!t.test(item.answer)) {
      this.$message({ message: '格式输入错误', type: 'info' })
      this.$nextTick(() => {
        item.answer = ''
      })
    }
  }

  private handlePictureCardPreview1 (file: any) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }

  private async getWeekSendMessage () {
    const data: any = await getWeekSendMessage({
      messageType: this.messageType,
      sellOrderId: this.pageType === 1 ? this.activeData.sellOrderId : '',
      classId: this.activeData.classId,
      isCurrentClass: this.returnData.isCurrentClass,
      createStr: this.returnData.createStr
    })
    this.weekList = data.weekStrList
  }

  private sureSendClick (type: any) {
    this.messageType = type
    this.getWeekSendMessage()
    this.weeksVisible = true
  }

  private async sureSend () {
    const list: any = []
    this.checkedWeeks.forEach((item: any) => {
      list.push(item.weekStr)
    })
    const { error }: any = await sendMessage({
      sellOrderId: this.pageType === 1 ? this.activeData.sellOrderId : '',
      classId: this.activeData.classId,
      weekStr: this.messageType === 1 ? [this.weeksradio] : list,
      messageType: this.messageType,
      studentIds: [this.activeData.studentId],
      isCurrentClass: this.returnData.isCurrentClass,
      createStr: this.returnData.createStr
    })
    if (!error) {
      const text = this.messageType === 1 ? '发布成功' : '更新成功'
      this.$message({ message: text, type: 'success' })
      this.resetDialog()
    }
  }

  // 老版本
  private clickitemradio1 (e: any, item3: any) {
    if (item3.canEdit) {
      item3.answer && (e === item3.answer) ? item3.answer = null : item3.answer = e
    }
  }

  private async clickitemradio (e: any, item3: any, list: any) {
    if (item3.canEdit) {
      item3.answer && (e === item3.answer) ? item3.answer = null : item3.answer = e
      // 全球华人导师/全球华人导师香港/全球华人导师海外/线下导师项目
      const weeklistData: any = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
      const courseTypeIdList = [6, 32, 39, 44]
      if (courseTypeIdList.includes(this.courseTypeId)) {
        // 过滤国内 Teaching Fellow/出勤，报告进展'的数组拼接参数
        const result = list.filter((item: any) =>
          item.questionClass === 'Teaching Fellow' &&
            (item.title === '出勤' || item.title === '报告进展')
        )
        // console.log(weeklistData(this.weekActive), 'weeklistData(this.weekActive)')
        const searchEvaluateObj: any = {
          studentId: this.activeData.studentId,
          studentName: this.activeData.studentName,
          classId: this.activeData.classId,
          weekStr: weeklistData[this.weekActive]
        }
        // 循环当前评价模块的所有选项
        const fieldMap: any = {
          出勤: 'isAttendanceNormal',
          报告进展: 'progressStatus'
        }
        result.forEach((itemAnswer: any) => {
          const targetKey = fieldMap[itemAnswer.title]
          if (targetKey && itemAnswer.answer) {
            searchEvaluateObj[targetKey] = itemAnswer.answer * 1
          }
        })
        const loading: any = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading'
        })
        const res: any = await getFeedbackGetcontent(searchEvaluateObj)
        const index = list.findIndex((item1: any) => item1.questionClass === 'Teaching Fellow' && item1.title === 'Suggestions or others')
        if (index > -1) {
          this.$set(list[index], 'answer', res.finalFeedback)
        }
        loading.close()
      }
      // 海外小组科研
      const courseTypeIdList1 = [1]
      if (courseTypeIdList1.includes(this.courseTypeId)) {
        // console.log(weeklistData(this.weekActive), 'weeklistData(this.weekActive)')
        if (item3.title === '是否为workshop' && item3.answer) {
          const titles = ['final类型', 'final进度', '学生贡献度']
          list.forEach((item: any) => {
            if (item.questionClass === 'TA' && titles.includes(item.title)) {
              this.$set(item, 'isHide', item3.answer * 1 === 2 ? true : '')
              this.$set(item, 'answer', null)
            }
          })
        }
        if (item3.title === 'final类型') {
          list.forEach((item: any) => {
            if (item.title === '学生贡献度') {
              this.$set(item, 'answer', null)
              this.$set(item, 'isHide', item3.answer * 1 === 2)
            }
            if (item.title === 'final进度') {
              this.$set(item, 'answer', null)
              this.$set(item, 'isHide', !item3.answer)
              item.chooseList.forEach((item2: any) => {
                if (item2.id * 1 === 4) {
                  item2.isHide = item3.answer * 1 === 2
                }
              })
            }
          })
        }
        const titleList = [
          { key: '出勤', value: 'isAttendanceNormal' },
          { key: '互动', value: 'interactionStatus' },
          { key: '学生在OH的表现好', value: 'officeHourStatus' },
          { key: '学生微信问过助教问题', value: 'wechatQuestionStatus' },
          { key: '学生在Univ AI主动提问', value: 'univAIQuestionStatus' },
          { key: '学生在Univ AI平台回应别人帖子', value: 'univAIResponseStatus' },
          { key: '是否为workshop', value: 'isWorkshop' },
          { key: 'final类型', value: 'finalType' },
          { key: 'final进度', value: 'finalProgress' },
          { key: '学生贡献度', value: 'hasInstructorFeedback' }
        ]
        const result = list.filter((item: any) =>
          item.questionClass === 'TA' &&
          titleList.some(t => t.key === item.title)
        )
        const searchEvaluateObj1: any = {
          studentId: this.activeData.studentId,
          studentName: this.activeData.studentName,
          classId: this.activeData.classId,
          weekStr: weeklistData[this.weekActive]
        }
        result.forEach((itemAnswer: any) => {
          const itemIndex: any = titleList.findIndex(item => item.key === itemAnswer.title && itemAnswer.answer)
          if (itemIndex > -1) {
            this.$set(searchEvaluateObj1, titleList[itemIndex].value, itemAnswer.answer * 1)
          }
        })
        const loading: any = this.$loading({
          lock: true,
          text: '拼命加载中',
          spinner: 'el-icon-loading'
        })
        const res: any = await getFeedbackGetcontent(searchEvaluateObj1)
        const index = list.findIndex((item1: any) => item1.questionClass === 'TA' && item1.title === '学生表现')
        if (index > -1) {
          this.$set(list[index], 'answer', res.finalFeedback)
        }
        loading.close()
      }
    }
  }

  private getIsShow (item3: any, list: any) {
    // 海外小组科研
    const courseTypeIdList1 = [1]
    if (courseTypeIdList1.includes(this.courseTypeId)) {
      const titles = ['final类型', 'final进度', '学生贡献度']
      const titles1 = ['final进度', '学生贡献度']
      if (item3.questionClass === 'TA' && titles.includes(item3.title) && list.find((item4: any) => item4.title === '是否为workshop' && !item4.answer)) {
        this.$set(item3, 'isHide', true)
        return !item3.isHide
      } else if (item3.questionClass === 'TA' && titles1.includes(item3.title) && list.find((item4: any) => item4.title === 'final类型' && !item4.answer)) {
        this.$set(item3, 'isHide', true)
        return !item3.isHide
      } else {
        return !item3.isHide
      }
    } else {
      return !item3.isHide
    }
  }

  private resetDialog () {
    this.weeksVisible = false
    this.weeksradio = null
    this.checkedWeeks = []
    this.messageType = null
  }

  private async addQuality () {
    if (this.qualityList[this.qualityList.length - 1].detail) {
      this.qualityList.push({ detail: '' })
    } else {
      this.$message({ message: '请输入内容，并保存', type: 'error' })
    }
  }

  private async saveQuality (item: any) {
    if (!item.detail) {
      this.$message({ message: '请输入内容', type: 'error' })
    } else {
      if (item.id) {
        const { error }: any = await editEvaluationInspector({ id: item.id, detail: item.detail })
        if (!error) {
          this.$message({ message: '修改回访成功', type: 'success' })
        }
      } else {
        const { error }: any = await addEvaluationInspector({ classId: this.activeData.classId, sellOrderId: this.activeData.sellOrderId, detail: item.detail })
        if (!error) {
          this.$message({ message: '新增回访成功', type: 'success' })
        }
      }
    }
  }

  // html2canvas 截图不支持 svg处理
  private async convertSvg2Canvas (type: any) {
    let svgElms: any = []
    // document.getElementsByTagName('svg')
    if (type === 1) {
      console.log(document.getElementsByClassName('exportDataPdfAll')[0], '--')
      svgElms = document.getElementsByClassName('exportDataPdfAll')[0].getElementsByTagName('svg')
    } else {
      svgElms = document.getElementsByClassName('exportDataPdf')[0].getElementsByTagName('svg')
    }
    // 回调
    const callbacks = []
    for (const svg of svgElms) {
      const parentElement: any = svg.parentElement
      if (parentElement.getElementsByTagName('canvas').length === 1) {
        return
      }
      const img = new Image()
      img.src = `data:image/svg+xml,${encodeURIComponent((new XMLSerializer()).serializeToString(svg))}`
      img.crossOrigin = 'anonymous'
      img.onload = async () => {
        const width = 180 // 圆形进度条宽度
        const height = 180
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx: any = canvas.getContext('2d')
        await ctx.drawImage(img, 0, 0, width, height)
        parentElement.append(canvas)
        svg.remove()
        img.remove()
      }
      // 代码
      // parentElement.append(img)
      callbacks.push(img.onload)
    }
    await Promise.all(callbacks)
  }

  // html2canvas 截图不支持 svg处理
  private async loadScript (src: any, callback = null) {
    await new Promise(resolve => {
      // 如果已经加载了本js，直接调用回调
      if (this.checkScriptLoaded(src)) {
        return resolve(callback)
      }
      const scriptNode: any = document.createElement('script')
      scriptNode.setAttribute('type', 'text/javascript')
      scriptNode.setAttribute('src', src)
      document.body.appendChild(scriptNode)
      if (scriptNode.readyState) { // IE 判断
        scriptNode.onreadystatechange = () => {
          if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
            return resolve(callback)
          }
        }
      } else {
        scriptNode.onload = () => resolve(callback)
      }
    })
  }

  // html2canvas 截图不支持 svg处理
  private async checkScriptLoaded (src: any) {
    const scriptObjs = Array.from(document.getElementsByTagName('script'))
    return scriptObjs.find(ele => ele.src.includes(src))
  }

  private async exportpdf () {
    const data: any = await getWeekStrPDF({ classId: this.activeData.classId })
    this.exportWeekFeedback = true
    this.importWeeksList = data
    this.importWeeksList.push(0)
  }

  private async exportExcel () {
    const data: any = await getWeekStrPDF({ classId: this.activeData.classId })
    this.exportWeekFeedbackExcel = true
    this.importWeeksList = data
    this.importWeeksList.push(0)
  }

  private async exportEvaluationExcel () {
    const flag = this.exportcheckedWeeks.findIndex((item: any) => item === 0)
    if (flag > -1) { this.exportcheckedWeeks.splice(flag, 1) }
    const args = { classId: this.activeData.classId, sellOrderId: this.activeData.sellOrderId, all: flag > -1, weeks: this.exportcheckedWeeks }
    const weeksStr = args.weeks.join(',')
    const argsStr = `classId=${args.classId}&sellOrderId=${args.sellOrderId}&all=${args.all}&weeks=${weeksStr}`
    const url = urlBase.eduBaseUrl + '/evaluation/exportInfoExcel?' + argsStr
    const a: any = document.createElement('a')
    a.href = url
    a.click()
  }

  private async sureImport () {
    this.exportDataPdf = null
    this.exportDataPdfData = {}
    this.exportDataPdfData = null
    this.loading = this.$loading({
      lock: true,
      text: '导出中...',
      spinner: 'el-icon-loading'
    })
    this.exportWeekFeedback = false
    const flag = this.exportcheckedWeeks.findIndex((item: any) => item === 0)
    if (flag > -1) {
      this.exportcheckedWeeks.splice(flag, 1)
    }
    const data: any = await exportWeekStrPDF({ classId: this.activeData.classId, sellOrderId: this.activeData.sellOrderId, all: flag > -1, weeks: this.exportcheckedWeeks })
    if (data) {
      this.exportDataPdfData = data
      this.exportcheckedWeeks = []
      await this.getexportpdfALL()
      await this.getexportpdf()
      await evaluationExport({ studentName: this.activeData.studentName })
    }
  }

  private async getexportpdf () {
    // 选择多个周日期下载图片
    if (this.exportDataPdfData.singleWeek && this.exportDataPdfData.singleWeek.length) {
      this.exportDataPdf = this.exportDataPdfData.singleWeek
      this.$nextTick(async () => {
        await Promise.all([this.loadScript('/static/js/html2canvas.min.js'), this.convertSvg2Canvas(2)]).then(() => {
          setTimeout(async () => {
            this.exportDataPdf.forEach(async (item: any, index: any) => {
              const refs: any = this.$refs
              if (refs['exportpdf' + index][0]) {
                await this.downloadPDF(refs['exportpdf' + index][0], this.activeData.studentName + '第' + item.weekStr + '周反馈')
              }
            })
          }, 1000)
        })
      })
    }
  }

  private async getexportpdfALL () {
    // 导出全部周 PDF数据处理加下载图片
    if (this.exportDataPdfData.allWeek && this.exportDataPdfData.allWeek.length) {
      this.$set(this.allExportDataPdf, 'type', 1)
      this.$set(this.allExportDataPdf, 'courseInfo', this.exportDataPdfData.allWeek[0].courseInfo)
      this.$set(this.allExportDataPdf, 'studentInfo', this.exportDataPdfData.allWeek[0].studentInfo)
      this.$set(this.allExportDataPdf, 'list', this.exportDataPdfData.allWeek)
      this.$nextTick(async () => {
        await Promise.all([this.loadScript('/static/js/html2canvas.min.js'), this.convertSvg2Canvas(1)]).then(() => {
          setTimeout(async () => {
            this.downloadPDF(this.$refs.exportpdfall, this.activeData.studentName + '全部反馈')
          }, 1000)
        })
      })
    }
  }

  private getWeekStr (week: any) {
    const list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十']
    const list1 = ['Session One', 'Session Two', 'Session Three', 'Session Four', 'Session Five', 'Session Six', 'Session Seven', 'Session Eight', 'Session Nine', 'Session Ten', 'Session Eleven', 'Session Twelve', 'Session Thirteen', 'Session Fourteen', 'Session Fifteen', 'Session Sixteen', 'Session Seventeen', 'Session Eighteen', 'Session Nineteen', 'Session Twenty']
    if (this.courseTypeId * 1 !== 31 && this.courseTypeId * 1 !== 30) {
      // return `第${week}节`
      const index = list.findIndex(item => week === item)
      if (index !== -1 && this.courseTypeId === 1) {
        return `第${week}节` + ' ' + list1[index]
      }
      return `第${week}节`
    } else if (this.courseTypeId * 1 === 30) {
      return `第${week}周`
    }
    return `第${week}节`
  }

  private getplaceholder (item: any) {
    let str = ''
    if (item.canEdit) {
      str = '请输入内容'
    }
    if (item.title === '预估成绩单出具时间') {
      str = '提交最终材料后的4-6周'
    }
    if (item.title === '资料提交清单') {
      str = `
      Submission checklist:
      Production log；
      Planning table/diagram；
      Literature table；
      Written Report (4500 words)；
      Presentation；
      Personal Information (Name Gender Birthday UCI (if available);
      Lecture Notes (Optional)；`
    }
    return str
  }

  // 修改出勤-自动关联摄像头
  private changeradio (item: any, item2: any, item3: any, item4: any) {
    if (item.answer === '2' || item.answer === '5') {
      this.evaluationAllWeekList[3].weekList[item2].questionClassList[item3].question[item4].answer = '2'
    }
  }
}
